export default "https://cdn-static.gokick.com/assets/4beacdc4d8fafa1e61a7f98396d8ad8b9ab7b90c/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";